class CartItems extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cartDrawer = document.querySelector('cart-drawer');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.isCartPage = !!document.body.classList.contains('template-cart');

    this.options = {
      showCartUpsell: false,
    };

    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.qtySelectors = this.querySelectorAll('quantity-input');
    this.qtySelectors.forEach((selector) => {
      selector.addEventListener('quantity-change', this.debouncedOnChange);
    });
  }

  disconnectedCallback() {
    this.qtySelectors.forEach((selector) => {
      selector.removeEventListener('quantity-change', this.debouncedOnChange);
    });
  }

  onChange(event) {
    const lineItemEl = event.target.closest('[data-cart-item]');
    this.updateQuantity(
      lineItemEl.dataset.cartItemKey,
      event.detail.quantity,
      document.activeElement.getAttribute('name'),
      lineItemEl,
    );
  }

  async updateQuantity(key, quantity, name, el) {
    this.enableLoading(key);

    this.sectionsToFetch = [
      ...this.getCartSectionsToRender().map(section => section.section),
    ];

    // if the cart page has upsell, fetch that section
    if (this.isCartPage && this.options.showCartUpsell) {
      this.sectionsToFetch = [
        ...this.sectionsToFetch,
        ...this.getCartRelatedSection().map(section => section.section),
      ];
    }
    // if the cart drawer has upsell. fetch that
    else if(this.cartDrawer && this.cartDrawer.options.showCartDrawerUpsell) {
      this.sectionsToFetch = [
        ...this.sectionsToFetch,
        ...this.getDrawerSectionsToRender().map(section => section.section),
      ];
    }

    const body = JSON.stringify( {
      id: key,
      quantity,
      sections: this.sectionsToFetch,
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        ...{ body },
      });

      if (!response.ok) {
        throw new Error(response.status);
      }

      this.parsedState = await response.json();

      // On success:

      if (+quantity === 0) {
        // create a new element with the undo text
        const textWrapper = document.createElement('p');
        if (window.cartStrings.reAddItem) {
          textWrapper.classList.add('cart-drawer-is-open:text-sm');
          textWrapper.innerHTML = window.cartStrings.removedItem.replace('[title]',el.dataset.cartItemName).replace('[link]','#');

          // append the element
          el.appendChild(textWrapper);
        }

        // animate the item to be removed
        el.querySelector('cart-remove-button')?.classList.add('hidden');
        el.querySelector('[data-cart-item-wrapper]').style.gridTemplateRows = '0fr';
        el.querySelector('[data-cart-item-wrapper]').addEventListener('transitionend', (event) => {
          // When the customer has removed an item, show what was removed with the option to add it again.
          if (window.cartStrings.reAddItem) {
            // remove the line item element
            event.target.remove();

            // add event listener
            const reAddLink = textWrapper.querySelector('a');
            reAddLink.addEventListener('click', (event) => {
              event.preventDefault();
              this.reAddItem(key, name, el);
            });
          }
          else {
            el.closest('li').remove();
          }
        });
      }
      else {
        // update the item key because it may have changed
        const currentItemKey = this.parsedState.items.find(item => item.id === +el.dataset.cartItemId);
        el.dataset.cartItemKey = currentItemKey.key;
      }

      if (this.parsedState.item_count !== 0) {
        // always render the sections
        this.updateContent(this.parsedState, el, name);
      }
      else if (window.cartStrings.reAddItem) {
        // hide the cart CTAs and totals
        document.querySelector('.js-cart-footer-contents').innerHTML = '';
      }
      else {
        this.classList.toggle('cart-is-empty', this.parsedState.item_count === 0);

        // hide the upsell
        // document.getElementById('cartRelated')?.classList.add('hidden');
      }
    }
    catch (error) {
      debug() && console.error('Error updating the item.', error);

      document.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
      document.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
      // document.getElementById('cart-errors').textContent = window.cartStrings.error;

      // Do a new fetch to the cart so you get the correct values of the item that had errors
      if (error.toString().includes('422')) {
        this.updateAfterError(key);
      }
    }
    finally {
      this.disableLoading();

      // update the shipping bar
      this.updateShippingBar();
    }
  }

  async updateAfterError(key) {
    const id = key.split(':')[0];
    if (!id) return;

    // Do a new fetch to the cart so you get the correct values of the item that had errors
    const body = JSON.stringify( {
      sections: this.sectionsToFetch,
      sections_url: window.location.pathname,
    });
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig('javascript'),
      ...{ body },
    });

    const parsedState = await response.json();
    const lineItemWithError = parsedState.items.filter(item => item.id == id)[0];

    // show the error
    if (lineItemWithError) this.showLineItemError(id, lineItemWithError.quantity);
  }

  updateContent(parsedState, el, name, renderAllSections = false) {
    if (!('sections' in parsedState)) return;

    let sectionsToRender = [
      ...this.getCartSectionsToRender(renderAllSections),
    ];
    if (this.isCartPage && this.options.showCartUpsell) {
      sectionsToRender = [
        ...sectionsToRender,
        ...this.getCartRelatedSection(),
      ];
    }
    else if (this.cartDrawer && this.cartDrawer.options.showCartDrawerUpsell) {
      sectionsToRender = [
        ...sectionsToRender,
        ...this.getDrawerSectionsToRender(),
      ];
    }

    sectionsToRender.forEach((section) => {
      if (section?.selector) {
        const selector = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }

        // update the cart drawer recommendations
        if (section.selector === '.js-cart-related-items') {
          setTimeout(() => {
            selector.classList.remove('opacity-0');
          }, 500);
        }
        if (section.selector === '.js-cart-related-items-swiper') {
          // init the swiper after a change
          setTimeout(() => {
            selector.querySelector('swiper-slider').init();
          }, 500);
        }
      }
    });

    if (el) el.querySelector(`[name="${name}"]`)?.focus();
  }

  // show error text for the line item
  showLineItemError(id, quantity) {
    document.getElementById(`Line-item-error-${id}`).querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]',quantity);
    document.getElementById(`Quantity-${id}`).value = quantity;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  async reAddItem(key, name, el) {
    const id = key.split(':')[0];
    const body = JSON.stringify({
      items: [
        {
          id,
          quantity: 1,
        },
      ],
      sections: this.sectionsToFetch,
      sections_url: window.location.pathname,
    });

    try {
    // add the gift to the cart
      const response = await fetch(routes.cart_add_url, { ...fetchConfig(),
        ...{ body } });

      if (response.status !== 200) {
        throw new Error(response.status);
      }
      const parsedState = await response.json();

      // render the sections
      this.updateContent(parsedState, el, name, true);
    }
    catch (error) {
      debug() && console.error('Error re-adding the item.', error);
    }
  }

  async updateShippingBar(getCart = false) {
    if (!window.shop.showFreeShippingBar) return;

    const threshold = +document.querySelector('[data-free-shipping-threshold]').dataset.freeShippingThreshold;
    const priceEl = document.querySelector('[data-free-shipping-no] span');
    const type = document.querySelector('[data-free-shipping-type]').dataset.freeShippingType;

    // get the cart
    let cart = this.parsedState;
    if (getCart) {
      try {
        const response = await fetch(routes.cart_url, {
          ...fetchConfig(),
        });

        if (!response.ok) {
          throw new Error(response.status);
        }

        cart = await response.json();
      }
      catch (error) {
        debug() && console.error(error);
      }
    }

    // free shipping achieved
    if ((cart.total_price >= threshold && type === 'price') || (cart.item_count >= threshold && type === 'items')) {
      document.querySelector('[data-free-shipping-threshold]').style.setProperty('--free-shipping-progress', 1);
      document.querySelector('[data-free-shipping-no]').classList.add('hidden');
      document.querySelector('[data-free-shipping-yes]').classList.remove('hidden');
    }
    else {
      // not yet there
      if (type === 'price') {
        priceEl.textContent = Shopify.formatMoney(threshold - cart.original_total_price);
        document.querySelector('[data-free-shipping-threshold]').style.setProperty('--free-shipping-progress', cart.original_total_price / threshold);
      }
      else {
        const difference = threshold - cart.item_count;
        const label = (difference === 1) ? ' item' : ' items';
        priceEl.textContent = `${difference + label}`;

        document.querySelector('[data-free-shipping-threshold]').style.setProperty('--free-shipping-progress', cart.item_count / threshold);
      }

      document.querySelector('[data-free-shipping-no]').classList.remove('hidden');
      document.querySelector('[data-free-shipping-yes]').classList.add('hidden');
    }

    // window.scrollTo({ top: document.getElementById('main-cart-footer').offsetTop - 84,
    //   behavior: 'smooth' });
  }

  getCartSectionsToRender(returnAll = false) {
    const defaultSections = [
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'theme-cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];

    if (returnAll) {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        ...defaultSections,
      ];
    }
    else {
      return defaultSections;
    }
  }

  getDrawerSectionsToRender() {
    return [
      {
        id: 'main-cart-recommendations',
        section: document.getElementById('main-cart-recommendations').dataset.id,
        selector: '.js-cart-related-items',
      },
      {
        id: 'cartDrawer',
        section: document.getElementById('cartDrawer').dataset.id,
        selector: '.js-cart-related-items-swiper',
      },
    ];
  }

  getCartRelatedSection() {
    return [
      {
        id: 'cartRelated',
        section: document.getElementById('cartRelated').dataset.id,
        selector: '.cart-related-items',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading() {
    document.querySelector('cart-items').classList.add('cart-items-is-loading');
    document.querySelector('[data-cart-loader-active="show"]')?.classList.remove('hidden');
    document.querySelector('[data-cart-loader-active="hidden"]')?.classList.add('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.querySelector('cart-items').classList.remove('cart-items-is-loading');
  }
}
if (!customElements.get('cart-items')) {
  customElements.define('cart-items', CartItems);
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const lineItemEl = event.target.closest('[data-cart-item]');
      this.closest('cart-items').updateQuantity(lineItemEl.dataset.cartItemKey, 0, null, lineItemEl);
    });
  }
}
if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify( {
        note: event.target.value,
      });
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{
          body,
        },
      });
    }, 300));
  }
}
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}
